import { DefaultTemplate } from "components/modal/templates";
import DateTime from "components/shared/datetime";
import Field from "components/shared/field";
import FileField from "components/shared/fileField";
import Loader from "components/shared/loader";
import Select from "components/shared/select";
import { dateTimeToView, dateToView, humanizedTimeRange } from "helpers/date";
import { scenarioAnswerValueTypesEnum, scenarioQuestionTypesEnum } from "helpers/enums";
import { createRequestForUploadFile } from "helpers/form";
import flatten from "lodash/flatten";
import React, { useState } from "react";
import { applyScenarioLogistAnswers, getBidScenarios, uploadFile } from "sources/books/scenarios";

const LogistAnswerForm = (props) => {
    const [answer, setAnswer] = useState();
    const [loading, setLoading] = useState();
    const { question, bidPointId, logistAnswerVal } = props;
    const { questionType, answerValueType, answerOptions, minValueCondition, maxValueCondition, id } = question;

    const onAnswerChange = ({ value }) => setAnswer(value);

    const saveAnswer = () => {
        setLoading(true);
        if (answerValueType === scenarioAnswerValueTypesEnum.File) {
            const paramsRequest = createRequestForUploadFile("file", answer);
            paramsRequest.body.append("questionId", id);
            paramsRequest.body.append("bidPointId", bidPointId);
            uploadFile(paramsRequest).then((result) => {
                setLoading(false);
                if (result) {
                    props.refreshData();
                    props.back();
                }
            });
        } else {
            applyScenarioLogistAnswers({
                driverAnswers: [
                    {
                        questionId: id,
                        bidPointId,
                        value: questionType === scenarioQuestionTypesEnum.Value ? answer : undefined,
                        selectedAnswerOptionIds: [
                            scenarioQuestionTypesEnum.SelectOne,
                            scenarioQuestionTypesEnum.SelectMultiple,
                        ].includes(questionType)
                            ? flatten([answer])
                            : undefined,
                    },
                ],
            }).then((result) => {
                setLoading(false);
                if (result) {
                    props.refreshData();
                    props.back();
                }
            });
        }
    };
    const answerField = () => {
        switch (questionType) {
            case scenarioQuestionTypesEnum.SelectOne:
            case scenarioQuestionTypesEnum.SelectMultiple:
                return (
                    <Select
                        options={answerOptions.map((item) => ({ label: item.text, value: item.id }))}
                        onChange={onAnswerChange}
                        value={answer}
                        inputProps={{ name: "answer" }}
                        isMulti={questionType === scenarioQuestionTypesEnum.SelectMultiple}
                        menuPortalTarget={document.body}
                    />
                );
            case scenarioQuestionTypesEnum.Value: {
                switch (answerValueType) {
                    case scenarioAnswerValueTypesEnum.DateTime:
                        return (
                            <DateTime
                                onChange={onAnswerChange}
                                value={answer}
                                inputProps={{ name: "answer" }}
                                inPortal
                            />
                        );
                    case scenarioAnswerValueTypesEnum.Date:
                        return (
                            <DateTime
                                onChange={onAnswerChange}
                                value={answer}
                                inputProps={{ name: "answer", type: "date" }}
                                inPortal
                            />
                        );
                    case scenarioAnswerValueTypesEnum.File:
                        return <FileField onChange={onAnswerChange} value={answer} inputProps={{ name: "answer" }} />;
                    case scenarioAnswerValueTypesEnum.TimeSpan:
                        return (
                            <Field
                                onChange={onAnswerChange}
                                value={answer}
                                inputProps={{ name: "answer" }}
                                type="timespan"
                            />
                        );
                    case scenarioAnswerValueTypesEnum.Integer:
                    case scenarioAnswerValueTypesEnum.Double:
                        return (
                            <Field
                                onChange={onAnswerChange}
                                value={answer}
                                inputProps={{
                                    name: "answer",
                                    type: "number",
                                    min: minValueCondition,
                                    max: maxValueCondition,
                                }}
                            />
                        );
                    default:
                        return <Field onChange={onAnswerChange} value={answer} inputProps={{ name: "answer" }} />;
                }
            }
            case scenarioQuestionTypesEnum.Instruction:
            default:
                return null;
        }
    };
    return (
        <div className={loading ? "loading" : ""}>
            {logistAnswerVal && (
                <div className="pb-3">
                    <h6>Ответ логиста:</h6>
                    {logistAnswerVal}
                </div>
            )}
            <h6>{question.text}</h6>
            {answerField()}
            <div className="d-flex justify-content-end pt-3">
                <div className="btn btn-sm btn-brand" onClick={saveAnswer}>
                    Сохранить
                </div>
            </div>
        </div>
    );
};

export default class ScenarioAnswersModal extends DefaultTemplate {
    state = {
        isLoading: true,
        data: null,
    };

    componentDidMount() {
        getBidScenarios(this.props.bid.id).then((data) => this.setState({ data, isLoading: false }));
    }

    renderBidPoint = (bidPoint, index) => {
        return (
            <div key={bidPoint.id} className="answer__list-card mb-3">
                <div className="card-header">
                    {index + 1}. {bidPoint.geozone.address}
                </div>
                <div className="card-body">{this.renderPointScenario(bidPoint.id)}</div>
            </div>
        );
    };

    createLogistAnswer = (question, bidPointId, logistAnswerVal = null) => {
        this.props.add({
            name: "default",
            title: "Изменение ответа водителя",
            windowMod: "wide",
            CustomBody: LogistAnswerForm,
            bodyData: {
                question,
                bidPointId,
                logistAnswerVal,
                refreshData: () => {
                    this.setState({ isLoading: true });
                    getBidScenarios(this.props.bid.id).then((data) => this.setState({ data, isLoading: false }));
                },
            },
        });
    };

    renderAnswer = (question, answer, canAnswerLogist = false, bidPointId) => {
        const { questionType, answerValueType, answerOptions } = question;
        if (!answer) {
            return canAnswerLogist ? (
                <div className="link font-size-14" onClick={() => this.createLogistAnswer(question, bidPointId)}>
                    Изменить ответ
                </div>
            ) : (
                <div />
            );
        }
        const answerVal = () => {
            switch (questionType) {
                case scenarioQuestionTypesEnum.SelectOne:
                case scenarioQuestionTypesEnum.SelectMultiple: {
                    const { selectedAnswerOptions } = answer;
                    return selectedAnswerOptions
                        .map((val) => {
                            const option = answerOptions.find((item) => item.id === val);
                            return option ? option.text : "";
                        })
                        .join("; ");
                }
                case scenarioQuestionTypesEnum.Value: {
                    switch (answerValueType) {
                        case scenarioAnswerValueTypesEnum.DateTime:
                            return dateTimeToView(answer.value);
                        case scenarioAnswerValueTypesEnum.Date:
                            return dateToView(answer.value);
                        case scenarioAnswerValueTypesEnum.File:
                            return answer.files.map((file) => (
                                <a key={file.id} href={file.accessUrlLink} download>
                                    {file.fileName}
                                </a>
                            ));
                        case scenarioAnswerValueTypesEnum.TimeSpan:
                            return humanizedTimeRange(answer.value);
                        default:
                            return answer.value;
                    }
                }
                case scenarioQuestionTypesEnum.Instruction:
                default:
                    return null;
            }
        };
        return (
            <div>
                {answerVal()}
                {canAnswerLogist && (
                    <>
                        <br />
                        <div
                            className="link font-size-14"
                            onClick={() => this.createLogistAnswer(question, bidPointId, answerVal())}
                        >
                            Изменить ответ
                        </div>
                    </>
                )}
            </div>
        );
    };

    renderPointScenario = (bidPointId) => {
        const scenarioData = this.state.data.find((item) => item.bidPointId === bidPointId);
        if (!scenarioData) {
            return null;
        }
        const { scenario } = scenarioData;
        return (
            <>
                <div>{scenario.name}</div>
                <div className="text-muted pb-3">{scenario.description}</div>
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Вопрос</th>
                            <th>Ответ водителя</th>
                            <th>Ответ логиста</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scenario.questions.map((question, i) => (
                            <tr key={question.id}>
                                <td>{i + 1}</td>
                                <td>{question.text}</td>
                                <td>{this.renderAnswer(question, question.answer)}</td>
                                <td>
                                    {this.renderAnswer(
                                        question,
                                        question.logistAnswer,
                                        true,
                                        bidPointId,
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return this.props.bid.bidPoints.map(this.renderBidPoint);
    };
}
